import Api from 'src/api/Base'

class GetMatchingShelfProductsById extends Api {
  requestUrl = `/api/ShelfProduct/${this.getParams().id}/Usage`
}

export default GetMatchingShelfProductsById
